"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10945],{

/***/ 10945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var DatepickerArrowsIcon = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "38px",
        height: "29px",
        viewBox: "0 0 38 29",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "Group-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "enter-arrow",
                    transform: "translate(0 13)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.675 1.275L21.675 6.375L4.845 6.375L9.435 1.785L7.65 0L0 7.65L7.65 15.3L9.435 13.515L4.845 8.925L24.225 8.925L24.225 1.275L21.675 1.275Z",
                        transform: "translate(0 0.0125)",
                        id: "Path",
                        fill: "#22b645",
                        stroke: "none"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "enter-arrow",
                    transform: "matrix(-1 0 0 -1 38 16)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.675 1.275L21.675 6.375L4.845 6.375L9.435 1.785L7.65 0L0 7.65L7.65 15.3L9.435 13.515L4.845 8.925L24.225 8.925L24.225 1.275L21.675 1.275Z",
                        transform: "translate(0 0.0125)",
                        id: "Path",
                        fill: "#ff4300",
                        stroke: "none"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DatepickerArrowsIcon);


/***/ })

}]);